import React from "react";
import { BookmarkAdd, BookmarkAdded } from "@mui/icons-material";
import { Box, Tab, Tabs, TextField } from "@mui/material";

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`translation-tabpanel-${index}`}
            aria-labelledby={`translation-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

export function LocaleTabs(props) {
    const { translations, tabValue, onTabChange, onTranslationChange, ...other } = props;
    //console.log("LocaleTabs", translations);
    const checkConditions = translations && translations.sameLabelTranslations && translations.sameLabelTranslations.length > 0;
    return (
        <Tabs
            value={tabValue}
            onChange={onTabChange}
            {...other}
        >
            {checkConditions && translations.sameLabelTranslations.map((translation, index) => (
                <Tab
                    key={index}
                    label={translation.locale}
                    icon={translation.languageId === null ? <BookmarkAdd /> : <BookmarkAdded />}
                    iconPosition={'end'}
                />
            ))}
        </Tabs>

    );
}

export function TranslationTextField(props) {
    const { translation, index, onTranslationChange, ...other } = props;
    return (
        <TextField
            id="outlined-multiline-static"
            label="Key translation"
            multiline
            rows={6}
            value={translation.content}
            onChange={(e) => onTranslationChange(index, e.target.value)}
            {...other}
        />
    );
}

// the following function will return the list of potential locales for the translation
export function getPotentialLocales() {
    return ['es', 'ca', 'en'];
}

export function removeCurlyBraces(str) {
    if (str && str.startsWith('{') && str.endsWith('}')) {
        return str.slice(1, -1);
    }
    return str;
}

export function updateObjectFieldsWithLabels(obj) {
    //console.log('updateObjectFieldsWithLabels (before) ', obj);
    Object.keys(obj).forEach(key => {
        const labelKey = `${key}_label`;
        if (Object.prototype.hasOwnProperty.call(obj, labelKey)) {
            obj[key] = obj[labelKey];
        }
    });
    //console.log('updateObjectFieldsWithLabels (after) ', obj);
    return obj;
}
